import {
  MipsResponseDTO,
} from 'dtos';
import {
  sendRequest,
} from 'utils/httpClient';

const getMipsSuggestion = (
  visitNoteId: number,
): Promise<MipsResponseDTO[]> => (
  sendRequest<MipsResponseDTO[]>({ url: `api/visitNote/getMipsSuggestion/${visitNoteId}` }, {
    method: 'GET',
  })
);

export default getMipsSuggestion;
